<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-600">
          <div class="modal-header">
            <slot name="header">Create a round change</slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-6">
                  <label for="from_date">From:</label>
                </div>
                <div class="col-6">
                  <label for="to_date">To:</label>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <DatePicker
                    mode="single"
                    v-model="from_date"
                    :attributes="attrs"
                    :available-dates="from_valid_dates"
                    :firstDayOfWeek="2"
                    color="blue"
                    is-inline
                    is-required
                  />
                </div>
                <div class="col-6">
                  <DatePicker
                    mode="single"
                    v-model="to_date"
                    :attributes="attrs"
                    :available-dates="to_valid_dates"
                    :firstDayOfWeek="2"
                    color="blue"
                    is-inline
                    is-required
                  />
                </div>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Close without save
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";

export default {
  name: "DatePickerModal",
  props: {
    item: {
      type: Object,
    },
    from_default: {
      type: Date,
      default: function() {
        return new Date();
      },
    },
    from_valid_dates: {
      type: Object,
      default: function() {
        return { start: new Date(), end: null };
      },
    },
    to_default: {
      type: Date,
      default: function() {
        return new Date();
      },
    },
    to_valid_dates: {
      type: Object,
      default: function() {
        return { start: new Date(), end: null };
      },
    },
  },
  data: () => ({
    from_date: null,
    to_date: null,
  }),
  mounted() {
    this.$nextTick(() => {
      this.requested_date = this.default;
    });
  },
  methods: {
    _save() {
      if (this.from_date == null) {
        alert("Please select a from date");
        return;
      } else if (this.to_date == null) {
        alert("Please select a to date");
        return;
      }
      this.$emit("save", {
        item: this.item,
        from: moment(this.from_date).format("yyyy-MM-DD"),
        to: moment(this.to_date).format("yyyy-MM-DD"),
      });
    },
    moment(arg) {
      return moment(arg);
    },
  },
  computed: {
    attrs() {
      return [
        {
          key: "today",
          highlight: {
            color: "teal",
          },
          dates: new Date(),
        },
      ];
    },
  },
  components: {
    DatePicker,
  },
};

// :available-dates='{ weekdays: [1] }' //https://vcalendar.io/dates.html
</script>
